import { NEUTRAL_1, NEUTRAL_10, NEUTRAL_2 } from '@/colors/colors';
import { css } from '@emotion/css';

export const styThead = css`
  > tr > th {
      background-color: ${NEUTRAL_1};
      padding: 14px 16px;
      position: sticky;
      top: 0px;
      z-index: 10;

      color: ${NEUTRAL_10};
      border-bottom: 1px solid ${NEUTRAL_2};

      text-align: left;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
